import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  gap: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FilterColumn = styled.aside`
  width: 250px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ResultsColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ResultsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 24px;
`;

export const ResultsCount = styled.h2`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin: 0;
`;

export const ResultsSubtext = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin: 4px 0 0;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  padding-bottom: 24px;
`;

export const FilterSection = styled.div`
  margin-bottom: 24px;
`;

export const FilterHeading = styled.h4`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text.dark.very};
  margin: 0 0 12px;
  font-weight: 600;
`;

export const FilterPanelWrapper = styled.div`
  background: ${({ theme }) => theme.colors.bgColor};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.metrics.radius.medium};
  padding: 24px;
`;

export const PriceLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.text.dark.medium};
  margin-top: 4px;
`;

export const ClearButton = styled.div`
  margin-top: 8px;
`;
